import React from 'react';
import Icon from '../../../components/AppIcon';
import ContractTableRow from './ContractTableRow';
import TemplateDocumentTableRow from './TemplateDocumentTableRow';

const SortHeaderButton = ({ label, sortKey, columnKey, sortDir, onSortColumn, className = '' }) => {
  const active = sortKey === columnKey;
  return (
    <button
      type="button"
      onClick={() => onSortColumn(columnKey)}
      className={`inline-flex items-center gap-1.5 text-left text-xs font-semibold text-foreground font-caption uppercase tracking-wider hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 rounded ${className}`}
    >
      <span>{label}</span>
      {active ? (
        <Icon
          name={sortDir === 'asc' ? 'ArrowUp' : 'ArrowDown'}
          size={14}
          className="shrink-0 text-primary"
        />
      ) : null}
    </button>
  );
};

const ContractTable = ({
  contracts,
  mixed = false,
  sortKey,
  sortDir,
  onSortColumn,
  onDownload,
  onEdit,
  onDelete,
  onSendToSignature,
  onDuplicateContract,
  onCancelSignature,
  onViewSignatureStatus,
  onGeneratePdf,
  onViewPdf,
  generatingPdfJobId = null,
}) => {
  const renderRow = (contract) => {
    const isGeneratingPdf =
      generatingPdfJobId != null &&
      String(contract.job_id) === String(generatingPdfJobId);

    if (mixed && contract.is_manual_signature) {
      return (
        <ContractTableRow
          key={contract.id}
          contract={contract}
          onDownload={onDownload}
          onEdit={onEdit}
          onDelete={onDelete}
          onSendToSignature={onSendToSignature}
          onDuplicateContract={onDuplicateContract}
          onCancelSignature={onCancelSignature}
          onViewSignatureStatus={onViewSignatureStatus}
          onGeneratePdf={onGeneratePdf}
          onViewPdf={onViewPdf}
          isGeneratingPdf={isGeneratingPdf}
        />
      );
    }

    if (mixed && contract.fillingType === 'custom_template') {
      return (
        <TemplateDocumentTableRow
          key={contract.id}
          contract={contract}
          onDownload={onDownload}
          onEdit={onEdit}
          onDelete={onDelete}
          onSendToSignature={onSendToSignature}
          onCancelSignature={onCancelSignature}
          onViewSignatureStatus={onViewSignatureStatus}
          onGeneratePdf={onGeneratePdf}
          onViewPdf={onViewPdf}
          isGeneratingPdf={isGeneratingPdf}
        />
      );
    }

    return (
      <ContractTableRow
        key={contract.id}
        contract={contract}
        onDownload={onDownload}
        onEdit={onEdit}
        onDelete={onDelete}
        onSendToSignature={onSendToSignature}
        onDuplicateContract={onDuplicateContract}
        onCancelSignature={onCancelSignature}
        onViewSignatureStatus={onViewSignatureStatus}
        onGeneratePdf={onGeneratePdf}
        onViewPdf={onViewPdf}
        isGeneratingPdf={isGeneratingPdf}
      />
    );
  };

  return (
    <div className="bg-card border border-border rounded-xl shadow-elevation-sm overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted/50 border-b border-border">
            <tr>
              <th className="px-4 md:px-6 py-3 text-left text-xs font-semibold text-foreground uppercase tracking-wider font-caption">
                <SortHeaderButton
                  label="Documento"
                  columnKey="name"
                  sortKey={sortKey}
                  sortDir={sortDir}
                  onSortColumn={onSortColumn}
                />
              </th>

              <th className="px-4 md:px-6 py-3 text-left text-xs font-semibold text-foreground uppercase tracking-wider font-caption hidden md:table-cell">
                <SortHeaderButton
                  label="Data de Criação"
                  columnKey="createdAt"
                  sortKey={sortKey}
                  sortDir={sortDir}
                  onSortColumn={onSortColumn}
                />
              </th>

              <th className="px-4 md:px-6 py-3 text-left text-xs font-semibold text-foreground uppercase tracking-wider font-caption">
                <SortHeaderButton
                  label="Status"
                  columnKey="status"
                  sortKey={sortKey}
                  sortDir={sortDir}
                  onSortColumn={onSortColumn}
                />
              </th>

              <th className="px-4 md:px-6 py-3 text-left text-xs font-semibold text-foreground uppercase tracking-wider font-caption hidden lg:table-cell">
                <SortHeaderButton
                  label="Data assinatura"
                  columnKey="signatureDate"
                  sortKey={sortKey}
                  sortDir={sortDir}
                  onSortColumn={onSortColumn}
                />
              </th>

              <th className="px-4 md:px-6 py-3 text-right text-xs font-semibold text-foreground uppercase tracking-wider font-caption">
                Ações
              </th>
            </tr>
          </thead>

          <tbody className="divide-y divide-border">
            {contracts.map(renderRow)}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ContractTable;
